import { render, staticRenderFns } from "./Articals.vue?vue&type=template&id=fc140c00&scoped=true&"
import script from "./Articals.vue?vue&type=script&lang=js&"
export * from "./Articals.vue?vue&type=script&lang=js&"
import style0 from "./Articals.vue?vue&type=style&index=0&id=fc140c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc140c00",
  null
  
)

export default component.exports